exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".autocomplete[data-v-4a96e0a6]{position:relative}.autocomplete-results[data-v-4a96e0a6]{padding:0;margin:0;border:1px solid #eee;min-height:30px;max-height:150px;width:100%;overflow:auto;position:absolute;background-color:#fff}.autocomplete-result[data-v-4a96e0a6]{list-style:none;text-align:left;padding:4px 8px;cursor:pointer}.autocomplete-result[data-v-4a96e0a6]:hover{background-color:#4399e1;color:#fff}.fade-enter-active[data-v-4a96e0a6],.fade-leave-active[data-v-4a96e0a6]{transition:opacity .5s}.fade-enter[data-v-4a96e0a6],.fade-leave-to[data-v-4a96e0a6]{opacity:0}", ""]);

// exports
